import { createSvgIcon } from "@mui/material";

export const AddPhotoIcon = createSvgIcon(
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.38951 8.98354H6.45651C4.42151 8.98354 2.77151 10.6335 2.77151 12.6685V17.5435C2.77151 19.5775 4.42151 21.2275 6.45651 21.2275H17.5865C19.6215 21.2275 21.2715 19.5775 21.2715 17.5435V12.6585C21.2715 10.6295 19.6265 8.98354 17.5975 8.98354L16.6545 8.98354" stroke="#149C84" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12.0214 2.19044V14.2314" stroke="#149C84" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M9.10632 5.11816L12.0213 2.19016L14.9373 5.11816" stroke="#149C84" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>,
  "AddPhotoIcon"
)